export default {

  methods: {
    async downloadCSVData (csvContent) {
      const data = encodeURI(csvContent)
      const fixedEncodedData = data.replaceAll('#', '%23')
      const link = document.createElement('a')
      link.setAttribute('href', fixedEncodedData)
      link.setAttribute('download', 'export.csv')
      link.click()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/export.js